<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<div class="d-flex justify-content-center pt-5">
  <div class="col-12 col-lg-5">
    <main class="form-signin border p-4 rounded">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="text-center mb-4">
          <h3 class="mb-3 font-weight-normal">Login</h3>
        </div>
        <div class="form-floating mb-3">
          <input formControlName="userName" type="text" placeholder="User Name" class="form-control"
            [class.is-invalid]="submitted && loginForm.get('userName')?.errors">
          <label for="userName">Username</label>
          <span class="text-danger" *ngIf="submitted && loginForm.get('userName')?.hasError('required')">
            Username is required
          </span>
        </div>
        <div class="form-floating mb-3 position-relative">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Password"
            class="form-control pe-5" [class.is-invalid]="submitted && loginForm.get('password')?.errors" id="password">
          <label for="password">Password</label>

          <!-- Eye icon -->
          <button type="button" class="btn position-absolute end-0"
            style="top: 50%; transform: translateY(-50%); margin-right: 0.75rem;" (click)="showPassword = !showPassword"
            tabindex="-1">
            <i class="{{ showPassword ? 'fa fa-eye-slash' : 'fa fa-eye' }}"></i>
          </button>

          <span class="text-danger" *ngIf="submitted && loginForm.get('password')?.hasError('required')">
            Password is required
          </span>
        </div>
        <div class="d-grid mt-4 px-1">
          <button class="btn btn-lg btn-info" type="submit">Login</button>
        </div>
      </form>
    </main>
  </div>
</div>
